import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { OnboardingWelcomeSettingsService } from '../services/onboarding-welcome-settings.service';

/** Admin-controlled kill switch for the onboarding welcome tour, independent of any single
 * feature's own launch status — lets it be paused/rolled out without touching essay marking
 * or live lessons entitlement. Fails closed: off until an admin flips onboarding_welcome_active
 * to 1 in Settings, and off if the settings call itself fails. */
export const onboardingWelcomeAccessGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const nav = router.currentNavigation();

  if (!inject(AuthenticationService).isUserLoggedIn()) {
    return router.parseUrl('/login' + (nav?.finalUrl ? `?redirect=${nav.finalUrl.toString()}` : ''));
  }

  return inject(OnboardingWelcomeSettingsService).getSettings().pipe(
    map((settings) => (settings.active ? true : router.parseUrl('/dashboard'))),
    catchError(() => of(router.parseUrl('/dashboard'))),
  );
};
